const DEFAULT_GA_ID = 'G-6D0HH4SHT1';
const GA_ID = (import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined) ?? DEFAULT_GA_ID;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
    __TAURI__?: unknown;
    __TAURI_INTERNALS__?: unknown;
  }
}

function isDesktop(): boolean {
  return typeof window !== 'undefined' && ('__TAURI__' in window || '__TAURI_INTERNALS__' in window);
}

let initialized = false;

export function initAnalytics(): void {
  if (initialized || typeof window === 'undefined') return;
  if (!GA_ID || isDesktop()) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  // gtag pushes arguments onto dataLayer; it must be a plain function (not arrow) to preserve `arguments`.
  window.gtag = function gtag() {
    window.dataLayer!.push(arguments);
  };
  window.gtag('js', new Date());
  // send_page_view: false — we emit page views manually on router navigation.
  window.gtag('config', GA_ID, { send_page_view: false });

  initialized = true;
}

export function trackPageView(path: string, title?: string): void {
  if (!initialized || !window.gtag) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title ?? document.title,
    page_location: window.location.href,
  });
}

export function trackEvent(name: string, params?: Record<string, unknown>): void {
  if (!initialized || !window.gtag) return;
  window.gtag('event', name, params);
}
